import { Component, OnInit } from '@angular/core';
import { ThemingService, ShopTheming } from 'src/app/theming.service';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';
import * as feather from 'feather-icons';
import { Region } from 'src/app/region/models/region.interface';
import { RegionBackendService } from 'src/app/region/services/regions.service';
import { Subscription } from 'rxjs';
import { LambdaService } from 'src/app/lambda.service';
import { co } from '@fullcalendar/core/internal-common';
declare var $: any;

@Component({
  selector: 'app-general-info',
  templateUrl: './general-info.component.html',
  styleUrls: ['./general-info.component.scss'],
})
export class GeneralInfoComponent implements OnInit {
  loading = false;
  loadingLocation = false;
  loadingInfo = false;
  loadingSocial = false;
  isEditingGeneral = false;
  isEditingLocation = false;
  isEditingSocial = false;
  isEditingAddress = false;

  shopInfo: any = {};
  shopSocialMedia: any;
  currencies: any;

  countries: any;
  public geoLocation1: Region[] = [];
  public geoLocation2: Region[] = [];
  public geoLocation3: Region[] = [];
  private _subscriptions: Subscription = new Subscription();
  public selectedProvinciaId?: string;
  public selectedCantonId?: string;
  public selectedDistritoId?: string;

  currentCurrencyCode: any = "";

  taxes: any[] = [];
  taxActive: any;
  taxId: number = 0;
  isLoginRequired: boolean = false;
  showFeedback: 'success' | 'error' | null = null;
  public shopTheme: ShopTheming[] = [];
  constructor(
    public apiService: ApiService,
    public themingService: ThemingService,
    private router: Router,
    private readonly _region: RegionBackendService,
    private lambdaService: LambdaService
  ) {
    this.shopTheme = this.themingService.shopTheming;
  }

  ngOnInit(): void {
    this.getShopData();
    this.getCountries();
    this._subscriptions.add(
      this._region.getSubregions(this._region.crId).subscribe((data) => {
        this.geoLocation3 = data;
      })
    );
    this.loadTaxes();
  }

  ngAfterViewInit() {
    feather.replace();
  }

  addEmail() {
    if (this.shopInfo.shopMail.length < 2) {
      this.shopInfo.shopMail.push('');
    }
  }

  removeEmail(index: number) {
    this.shopInfo.shopMail.splice(index, 1);
  }

  trackByIndex(index: number, _: any): number {
    return index;
  }

  switchEditingAll() {
    this.isEditingGeneral = true;
    this.isEditingLocation = true;
  }

  switchCancelEditingAll() {
    this.isEditingGeneral = false;
    this.isEditingLocation = false;
  }

  switchEditingLocation() {
    this.isEditingLocation = !this.isEditingLocation;
    // this.isEditingLocation === false ? location.reload() : null;
  }

  switchEditingSocial() {
    this.isEditingSocial = !this.isEditingSocial;
    // this.isEditingSocial === false ? location.reload() : null;
  }

  switchEditingAddress() {
    this.isEditingAddress = !this.isEditingAddress;
  }

  changeCurrency(event: Event) {
    const element = event.target as HTMLInputElement;
    this.shopInfo.currencyId = parseInt(element.value);
    let currentCurrency = this.currencies.find((c: any) => c.currencyId === this.shopInfo.currencyId);
    this.currentCurrencyCode = currentCurrency.currencyCode;
  }

  getTaxName(): string {
    const tax = this.taxes.find(t => t.taxId === this.taxId);
    return tax?.taxName || '';
  }

  changeCountry(event: Event): void {
    this.geoLocation1 = [];
    this.geoLocation2 = [];
    this.geoLocation3 = [];
    const countryId = (event.target as HTMLSelectElement).value;
    this.shopInfo.countryId = parseInt(countryId);

    this.shopInfo.shopGeoLocation1Id = '';
    this.shopInfo.shopGeoLocation2Id = '';
    this.shopInfo.shopGeoLocation3Id = '';

    if (this.shopInfo.countryId === 1) {
      this._subscriptions.add(
        this._region.getRootRegionByISO2('cr').subscribe(rootRegion => {
          if (rootRegion?.id) {
            this._region.getSubregions(rootRegion.id).subscribe(provinces => {
              this.geoLocation1 = provinces;
            });
          }
        })
      );
    }
  }

  changeGeoLocation1(event: Event): void {
    const provinciaId = (event.target as HTMLSelectElement).value;
    this.shopInfo.shopGeoLocation1Id = provinciaId;
    this.shopInfo.shopGeoLocation2Id = '';
    this.shopInfo.shopGeoLocation3Id = '';
    this.geoLocation2 = [];
    this.geoLocation3 = [];

    this._subscriptions.add(
      this._region.getSubregions(provinciaId).subscribe((data) => {
        this.geoLocation2 = data;
      })
    );
  }

  changeGeoLocation2(event: Event): void {
    const cantonId = (event.target as HTMLSelectElement).value;
    this.shopInfo.shopGeoLocation2Id = cantonId;
    this.shopInfo.shopGeoLocation3Id = '';
    this.geoLocation3 = [];

    this._subscriptions.add(
      this._region.getSubregions(cantonId).subscribe((data) => {
        this.geoLocation3 = data;
      })
    );
  }

  changeGeoLocation3(event: Event): void {
    const distritoId = (event.target as HTMLSelectElement).value;
    this.shopInfo.shopGeoLocation3Id = distritoId;
    this.shopInfo.regionId = distritoId;
  }

  getCountries() {
    this.lambdaService
      .getCountries()
      .then((data: any) => {
        this.countries = data;
      })
      .catch((error: Error) => {
        console.error(error);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
  }

  loadRegionHierarchy(districtId: string): void {
    this._region.getRegionHierarchy(districtId).subscribe((response) => {
      const district = response;
      const canton = response.parent;
      const province = response.parent?.parent;

      this.shopInfo.shopGeoLocation3Id = district.id;
      this.shopInfo.shopGeoLocation2Id = canton?.id || null;
      this.shopInfo.shopGeoLocation1Id = province?.id || null;
      this.shopInfo.regionId = district.id;

      this._region.getSubregions(canton.id).subscribe((distritos) => {
        this.geoLocation3 = distritos;

        this._region.getSubregions(province.id).subscribe((cantones) => {
          this.geoLocation2 = cantones;

        });
      });
    });
  }

  getCountryName(): string {
    const country = this.countries?.find((c: any) => c.countryId === this.shopInfo.countryId);
    return country ? country.countryName : 'N/A';
  }

  getProvinceName(): string {
    return this.geoLocation1.find(g => g.id === this.shopInfo.shopGeoLocation1Id)?.name || 'N/A';
  }

  getCantonName(): string {
    return this.geoLocation2.find(g => g.id === this.shopInfo.shopGeoLocation2Id)?.name || 'N/A';
  }

  getDistrictName(): string {
    return this.geoLocation3.find(g => g.id === this.shopInfo.shopGeoLocation3Id)?.name || 'N/A';
  }

  getGeoLocation1(geoLocationId: number) {
    this.apiService
      .getGeoLocation(1, geoLocationId)
      .then((data: any) => {
        this.geoLocation1 = data;
      })
      .catch((error: Error) => {
        console.error(error);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
  }

  getGeoLocation2(geoLocationId: number) {
    this.apiService
      .getGeoLocation(2, geoLocationId)
      .then((data: any) => {
        this.geoLocation2 = data;
      })
      .catch((error: Error) => {
        console.error(error);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
  }

  getGeoLocation3(geoLocationId: number) {
    this.apiService
      .getGeoLocation(3, geoLocationId)
      .then((data: any) => {
        this.geoLocation3 = data;
      })
      .catch((error: Error) => {
        console.error(error);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
  }

  getShopData() {
    this.lambdaService
      .getShopData(this.themingService.shopId)
      .then((data: any) => {
        this.shopInfo = data.info || {};
        this.shopInfo.shopMail = this.shopInfo.shopMail
          ? this.shopInfo.shopMail.split(',').map((e: string) => e.trim())
          : [];

        this.shopInfo.shopMailString = this.shopInfo.shopMail.join(', ');

        // this.shopInfo = data.info[0];
        this.shopSocialMedia = data.socialMedia;
        this.currencies = data.currency;
        if (this.currencies) {
          let currentCurrency = this.currencies.find((c: any) => c.currencyId === this.shopInfo.currencyId);
          this.currentCurrencyCode = currentCurrency.currencyCode;
        }
        this._region.getSubregions(this._region.crId).subscribe((provincias) => {
          this.geoLocation1 = provincias;

          const distritoId = this.shopInfo.shopGeoLocation3Id;
          if (distritoId && distritoId !== "0") {
            this.loadRegionHierarchy(distritoId);
          }
        })
      })
      .catch((error: Error) => {
        console.error(error);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
  }

  loadTaxes() {
    this.loading = true;
    this.lambdaService
      .getTaxes(this.themingService.shopId)
      .then((data: any) => {
        const taxList = data.taxes || [];
        this.taxes = taxList.filter((t: any) => t.taxValue === 0);
        const activeTaxes = taxList.filter((t: any) => t.taxActive === '1');
        const lastActiveTax = activeTaxes.pop();
        if (lastActiveTax) {
          this.taxId = lastActiveTax.taxId;
        }
        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
        this.loading = false;
      });
  }

  changeTax(event: Event) {
    const element = event.target as HTMLInputElement;
    this.taxId = parseInt(element.value);
  }

  updateShopInfo() {
    this.loadingInfo = true;

    this.shopInfo.shopMailString = (this.shopInfo.shopMail as string[])
      .map((e: string) => e.trim())
      .filter((e: string) => e.length > 0)
      .join(',');

    this.lambdaService.updateShopInfo(
      this.themingService.shopId,
      this.shopInfo.shopName,
      this.shopInfo.shopMail.join(','),
      this.shopInfo.currencyId,
      this.shopInfo.countryId,
      this.shopInfo.shopGeoLocation1Id,
      this.shopInfo.shopGeoLocation2Id,
      this.shopInfo.shopGeoLocation3Id,
      this.taxId,
      this.shopInfo.shopAddress
    )
      .then((data: any) => {
        $('#successShopDataModal').modal('show');
        this.getShopData();
        this.loadingInfo = false;
        this.switchEditingAll();
        this.isEditingGeneral = false;
        this.isEditingLocation = false;
      })
      .catch((error) => {
        console.error(error);
        this.loadingInfo = false;
      });
  }

  updateShopSocialMedia() {
    this.loadingSocial = true;
    let socialMediaData = this.shopSocialMedia.map((socialMedia: any) => ({
      socialMediaName: socialMedia.socialMediaName,
      socialMediaURL: socialMedia.socialMediaURL
    }));
    // console.log(socialMediaData)
    // console.log(JSON.stringify(socialMediaData))
    this.lambdaService.updateShopSocialMedia(
      this.themingService.shopId,
      socialMediaData
    )
      .then((data: any) => {
        // console.log(data);
        // if(data.status === 200){
        //   $('#successSupplierModal').modal('show');
        //   this.loading = false;
        // }
        // else{
        //   $('#errorSupplierModal').modal('show');
        // }
        $('#successShopDataModal').modal('show');
        this.getShopData();
        this.loadingSocial = false;
        this.switchEditingSocial();
      })
      .catch((error) => {
        console.error(error);
        this.loadingSocial = false;
      });
  }


  closeModal() {
    $('#successShopDataModal').modal('hide');
  }

  updateLoginRequirement(event: any) {
    this.isLoginRequired = event.checked;
    const status = this.isLoginRequired ? 1 : 0;

    this.showFeedback = null;

    this.lambdaService
      .updateLoginRequirement(status, this.themingService.shopId)
      .then((response: any) => {
        console.log('response login:', response);

        const result = response?.result;

        if (result && result.affectedRows > 0) {
          this.showFeedback = 'success';
        } else {
          this.showFeedback = 'error';
        }

        setTimeout(() => (this.showFeedback = null), 2000);
      })
      .catch((error) => {
        console.error('Error al actualizar login requirement:', error);
        this.showFeedback = 'error';
        setTimeout(() => (this.showFeedback = null), 2000);
      });
  }
  
}

